<script setup>
import { computed } from 'vue';
const props = defineProps({
  type: { type: String, required: true },
  icon: { type: String, default: 'i-lucide-plug' },
});
const logos = {
  tecimob: '/integrations/tecimob.png',
  sienge: '/integrations/sienge.png',
  tool_tecimob: '/integrations/tecimob.png',
  tool_sienge: '/integrations/sienge.png',
  tool_build_booking_link: '/integrations/omnibees.png',
};
const src = computed(() => logos[props.type]);
</script>

<template>
  <img v-if="src" :src="src" alt="" class="size-5 rounded object-contain" />
  <span v-else :class="icon" />
</template>
